import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { de } from 'date-fns/locale/de'
import { enUS } from 'date-fns/locale/en-US'
import { useSelector } from 'react-redux'
import { IUser } from '../../interface/IUser'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import React from 'react'

const ReportPrintDetails = (props: any) => {
    const { month } = props as { month: Date }

    const { t, i18n } = useTranslation()
    const user: IUser = useSelector((state: any) => state.user?.value)

    return (
        <Box className="printContent" sx={{ mb: 2 }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ color: 'black' }}>
                <Grid size={6}>
                    <Typography variant="h5">
                        {t('report.monthlyreport')} {month ? format(month, 'LLLL', { locale: i18n.language === 'de' ? de : enUS }) : ''} ({user.worker.mserp_name})
                    </Typography>
                    {user.worker.mserp_employmentcategory !== 'FAK' && (
                        <Typography>
                            {t('report.personnelnumber')}: {user.worker.mserp_personnelnumber}
                        </Typography>
                    )}
                    <Typography>
                        {t('report.resourcenumber')}: {user.resource.mserp_resourceid}
                    </Typography>
                </Grid>
                <Grid size={6} sx={{ textAlign: 'end' }}>
                    <Typography sx={{ fontWeight: 'bold' }}>{'Mercedes-Benz Tech Innovation GmbH'}</Typography>
                    <Typography>{i18n.language === 'de' ? format(new Date(), 'dd.MM.yyyy - HH:mm') + ' Uhr' : format(new Date(), 'MM/dd/yyyy - h:mm a')}</Typography>
                    <Typography>{user.worker.mserp_identityemail}</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ReportPrintDetails
